import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { NoResourcesAvailable } from 'components/NoResourcesAvailable'

const NoCreatePermission: FunctionComponent = () => {
  const { t } = useTranslation()

  return (
    <NoResourcesAvailable
      title={t('secrets.secretDefinitionListing.noCreatePermission.title')}
      supportText={t(
        'secrets.secretDefinitionListing.noCreatePermission.content'
      )}
      data-testid="no-create-permission-secret-definition"
    />
  )
}

export default NoCreatePermission
